// mds-dojo — dijit/_FocusMixin — FAITHFUL port of references/dijit/_FocusMixin.js.
// Mixin that flags a widget to receive _onFocus()/_onBlur() notifications from the
// focus manager (sets _focusManager = the dijit/focus singleton). Also extends
// _WidgetBase with the base focused flag + onFocus/onBlur/_onFocus/_onBlur (put
// there via lang.extend so they're last in the inheritance chain, exactly as dojo).
// declare from the faithful runtime.
import focus from './focus';
import _WidgetBase from './_WidgetBase';
import declare from '../dojo/_base/declare-runtime'; // declare
import lang from '../dojo/_base/lang'; // lang.extend

// We don't know where _FocusMixin will occur in the inheritance chain, but we need the _onFocus()/_onBlur() below
// to be last in the inheritance chain, so mixin to _WidgetBase.
lang.extend(_WidgetBase, {
  // focused: [readonly] Boolean
  //		This widget or a widget it contains has focus, or is "active" because
  //		it was recently clicked.
  focused: false,

  onFocus: function () {
    // Called when the widget becomes "active" because it or a widget inside of it
    // either has focus, or has recently been clicked.
  },

  onBlur: function () {
    // Called when the widget stops being "active" because focus moved to something
    // outside of it, or the user clicked somewhere outside of it, or the widget was hidden.
  },

  _onFocus: function () {
    // This is where widgets do processing for when they are active, such as changing
    // CSS classes.  See onFocus() for more details.
    this.onFocus();
  },

  _onBlur: function () {
    // This is where widgets do processing for when they stop being active, such as
    // changing CSS classes.  See onBlur() for more details.
    this.onBlur();
  },
});

export default declare('dijit._FocusMixin', null, {
  // summary:
  //		Mixin to widget to provide _onFocus() and _onBlur() methods that
  //		fire when a widget or its descendants get/lose focus

  // flag that I want _onFocus()/_onBlur() notifications from focus manager
  _focusManager: focus,
});
